import { render } from "./ScrollingTable.vue?vue&type=template&id=fe519a1c&scoped=true"
import script from "./ScrollingTable.vue?vue&type=script&lang=js"
export * from "./ScrollingTable.vue?vue&type=script&lang=js"

import "./ScrollingTable.vue?vue&type=style&index=0&id=fe519a1c&scoped=true&lang=scss"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal_claud/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe519a1c"]])

export default __exports__